import { ToolbarButton } from "../../lib/ui/toolbar/buttons";
export class ColorizeButton extends ToolbarButton {
    constructor(layer) {
        super('brush', 'Colorize Selected Parcels', 'colorizeButton');
        this.layer = layer;
    }
    _action() {
        this.layer.start_colorize();
    }
}
